export function formatDateTime(value?: string): string {
  if (!value) return '-';

  const date = new Date(value);

  const datePart = date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: '2-digit',
    year: 'numeric',
  });

  const timePart = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true, // set false for 24-hour format
  });

  return `${datePart} at ${timePart}`;
}
